import { Typography } from '@mui/material';

// Exact gradient stops from the retired 1000-referral.svg asset — no theme tokens exist for these.
const HERO_GRADIENT_START = '#A411AE';
const HERO_GRADIENT_END = '#591C5C';

interface ReferralHeroTextProps {
    rewardText: string;
}

export default function ReferralHeroText({ rewardText }: Readonly<ReferralHeroTextProps>) {
    return (
        <Typography
            component="span"
            sx={{
                background: `linear-gradient(90deg, ${HERO_GRADIENT_START}, ${HERO_GRADIENT_END})`,
                backgroundClip: 'text',
                fontSize: '4.75rem', // Sized to fill the ~115px hero strip like the retired SVG.
                fontWeight: 700,
                lineHeight: 1,
                textAlign: 'center',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
            }}>
            {rewardText}
        </Typography>
    );
}
